import { render, staticRenderFns } from "./AvailableModules.vue?vue&type=template&id=4ef43c06"
import script from "./AvailableModules.vue?vue&type=script&lang=js"
export * from "./AvailableModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports